export default {
  title: "Пользователи",
  total: "Всего",

  admin: "Администратор",
  controlAccess: "Доступ к управлению",

  writeAccess: "Доступ к редактированию",
  readAccess: "Доступ только к чтению",
  adminAccess: "Администратор",

  addUserBtn: "Добавить пользователя",
  manageUsersBtn: "Управление пользователями",
  lookUsersBtn: "Посмотреть пользователей",
  notification:
    "Добавьте пользователя Вашего личного кабинета (коллегу или представителя застройщика)",
  pluralize: ["пользователь", "пользователя", "пользователей"],

  modal: {
    addUserBtn: "Добавить пользователя",
    addUserTitle: "Добавить пользователя",
    userAccessFieldTitle: "Доступ пользователя",
    userAccessRead: "Только чтение",
    userAccessWrite: "Редактирование",
    adminAccessWrite: "Администратор",
    installer: "Застройщик",
    edit: "Может редактировать",
    read: "Может просматривать",
    addHelpMessage:
      "На указанный e-mail придет письмо, которое позволит <br> активировать все возможности личного кабинета.",

    submitBtn: "Добавить",
    submittingBtn: "Добавление...",

    removeAllBtn: "Удалить всех",
    removeAllMessage:
      "Вы уверены, что хотите удалить всех пользователей, кроме администраторов?",

    admin: "Администратор",
    notActivated: "Аккаунт не активирован",

    inviteAlreadyExistsError: "Инвайт уже создан для данного e-mail",
    userFromDifferentCompanyError: "Пользователь принадлежит другой компании",
    unknownError: "Неизвестная ошибка",

    inviteResentSuccessMessage: "Приглашение выслано повторно",
    inviteResentErrorMessage: "Произошла ошибка при отправке инвайта",
    inviteResentTimeoutErrorMessage:
      "Код доступа уже отправлен на указанную почту, если письмо не пришло, то подождите 5 минут и попробуйте снова",

    accessUpdateSuccess: "Уровень доступа пользователя изменён",
    accessUpdateFail:
      "Произошла ошибка при изменении уровня доступа пользователя",

    addUserSuccessMessage: "Приглашение отправлено",
    adminRoleDescription:
      "Возможность вносить изменения в данные Вашего личного кабинета, редактировать, добавлять и удалять, пользователей, оформлять пропуска и заказы услуг.",
    editRoleDescription:
      "Возможность вносить изменения в данные Вашего личного кабинета, оформлять пропуска и заказы услуг.",
    readRoleDescription: "Просмотр информации в Вашем личном кабинете.",
    installRoleDescription:
      "Представитель фирмы-застройщика, возможность оформлять заказы услуг."
  }
};
